// extracted by mini-css-extract-plugin
module.exports = {"alert-heading":"view-alert_alert-heading__1zesA","alert-body":"view-alert_alert-body__3idfR"};